export const base_path = '/';
export const image_path = '/';

// API URLs now use environment variable REACT_APP_API_URL
// Fallback to localhost if not set
export const api_url = process.env.REACT_APP_API_URL || 'https://chemplastapi-bfh6bvhtbma9gecy.centralus-01.azurewebsites.net/api/';
export const dev_api_url = process.env.REACT_APP_API_URL || 'https://chemplastapi-bfh6bvhtbma9gecy.centralus-01.azurewebsites.net/api/';

